<div *ngIf="showErrors" class="alert valign-children-middle" id="error-main-container">
    <div class="alert-error" role="img" aria-label="Error" aria-hidden="true">
        <i class="icon-badgealert"></i>
    </div>
    <div>
        <h2>Error</h2>
        <p>Something went wrong. Please try again.</p>
    </div>
    <div class="pull-right close" (click)="dismissInfo()" role="img" aria-label="close" tabindex="0"></div>
</div>
<div class="main-div">
    <div class="review-section">
        <p class="review-heading">{{reviewAccounts.reviewHeading}}</p>
        <br>
        <div class="review-info">
            <!-- <div class="first-block review-blocks">
                <p class="review-block-heading">{{reviewAccounts.fanLabel}}</p>
                <p class="review-block-value">{{enrolledData.foundationAccountNumber}}</p>
            </div>
            <div class="second-block review-blocks">
                <p class="review-block-heading">{{reviewAccounts.enrollmentType}}</p>
                <p class="review-block-value">{{enrolledData.serviceRequested}}</p>
            </div>
            <div class="third-block review-blocks">
                <p class="review-block-heading">{{reviewAccounts.billingAccount}}</p>
                <p class="review-block-value">{{enrolledData.billingAccountNumber}}</p>
            </div> -->
            <div class="fan-info">
                <app-customgrid [gridOptions]="gridOptions">
                    <ng-template let-row="row">
                        <li class="bullet-points bold-heading">{{row}}</li>
                    </ng-template>
                </app-customgrid>
            </div>
            <div class="offer-types-info">
                <p class="bold-heading offer-heading">Private Routing Offer Type</p>
                <ul *ngFor="let offer of enrolledData.serviceRequested">
                    <li class="bullet-points">{{offer}}</li>
                </ul>
            </div>
        </div>
        <br>
    </div>
    <br>
    <hr>
    <div class="contact-section">
        <p class="contact-heading">{{reviewAccounts.contactHeading}}</p>
        <p class="contact-fields email-field"><span class="bold-heading">{{reviewAccounts.phoneNumberLabel}}</span>
            {{enrolledData.customerPhoneNumber}}</p>
        <p class="contact-fields added-links"><span class="bold-heading">{{reviewAccounts.preferredEmail}}</span>
            {{enrolledData.emailAddress}}</p>
        <p class="contact-fields phone-field"><span class="bold-heading">{{reviewAccounts.preferredContactName}}</span>
            {{enrolledData.customerName}}</p>
        <p class="contact-fields phone-field"><span
                class="bold-heading">{{reviewAccounts.preferredContactNumber}}</span>
            {{enrolledData.alternateCustomerPhoneNumber}}</p>
        <p class="contact-fields phone-field"><span
                class="bold-heading">{{reviewAccounts.preferredTimeToContact}}</span> {{enrolledData.bestTimeToContact}}
        </p>
        <!-- <a
            class="added-links" [routerLink]="['/efota/enrollment/selectaccounts']">{{reviewAccounts.change}}</a> <br> -->
        <!-- <p class="contact-fields added-links">{{reviewAccounts.stateLabel}} {{enrolledData.state}}</p><a
            class="added-links" [routerLink]="['/efota/enrollment/selectaccounts']">{{reviewAccounts.change}}</a> <br>
        <p class="contact-fields added-links">{{reviewAccounts.zipLabel}} {{enrolledData.zipCode}}</p><a
            class="added-links" [routerLink]="['/efota/enrollment/selectaccounts']">{{reviewAccounts.change}}</a> <br>
        <p class="contact-fields added-links">{{reviewAccounts.timeToContact}} {{enrolledData.bestTimeToContact}}</p><a
            class="added-links" [routerLink]="['/efota/enrollment/selectaccounts']">{{reviewAccounts.change}}</a> <br> -->
    </div>
    <hr>
    <!-- <div class="ctn-section" *ngIf="isGroupBased">
        <p class="ctn-heading">{{reviewAccounts.enrollCtns}}</p>
        <p class="ctn-file-name added-links">{{reviewAccounts.youHaveUploaded}} {{uploadedFileName}}</p>
        <a class="added-links" [routerLink]="['/efota/enrollment/selectaccounts']">{{reviewAccounts.change}}</a>
    </div>
    <div class="notification-section">
        <p class="notification-heading">{{reviewAccounts.notificationHeading}}</p>
        <p class="notification-type added-links">{{reviewAccounts.sendNotifications}}
            {{enrolledData.notificationPreference}}</p>
        <a class="added-links" [routerLink]="['/efota/enrollment/selectaccounts']">{{reviewAccounts.change}}</a>
    </div> -->
    <div class="acknowledgement-section">
        <div class="acknowledgement-sub-section">
            <p class="acknowledgement-heading">{{reviewAccounts.acknowledgement}}</p>
            <p class="acknowledgement-description">{{reviewAccounts.acknowledgementDescription}}</p>
            <div class="confirm-section">
                <label class="checkbox" for="confirmSubmission">
                    <input aria-describedby="confirmSubmit" #confirm type="checkbox" id="confirmSubmission"
                        aria-label="Confirm Submission" name="Confirm Submission" (click)="enableSubmit()">
                    <i class="skin"></i>
                    <span id="confirmSubmit">{{reviewAccounts.understand}}</span>
                </label>
            </div>
        </div>
    </div> <br>
    <div class="submit-section">
        <button class="btn btn-secondary labels-inline" id="requestEnrollment" [disabled]="isDisabled"
            (click)="continueToNext()">{{reviewAccounts.requestEnrollment}}</button>
        <a id="cancel-link" [routerLink]="['/fiveg/enrollment/selectaccounts']"
            class="labels-inline">{{reviewAccounts.cancel}}</a>
    </div><br>
</div>